"use client";

import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import api from "../utils/api";

export default function Register() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post(
        "/users/register",
        {
          username,
          email,
          password,
        },
        { withCredentials: true },
      );

      alert(
        res.data.message || "Registeration Success. Redirecting to Login Now!",
      );
      navigate("/login");
    } catch (err) {
      console.error("Error: ", err);
    }
  };
  return (
    <>
      <div className="h-screen flex">
        <div className="w-1/2 bg-gray-900 flex flex-col items-center justify-center text-white">
          <div className="mb-8">
            <img
              src="/bit.png"
              alt="Logo"
              width={250}
              height={250}
              className="rounded-full object-cover shadow-lg"
            />
          </div>
        </div>

        <div className="w-1/2 bg-white flex items-center text-black">
          <form onSubmit={handleRegister} className="my-auto mx-auto w-80">
            <h1 className="text-3xl font-bold mb-4">Create Account</h1>
            <p className="text-gray-500 mb-6">
              Please Enter Your Details to Sign Up
            </p>

            <input
              type="text"
              placeholder="Username"
              className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-gray-700"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />

            <input
              type="email"
              placeholder="Email"
              className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-gray-700"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              type="password"
              placeholder="Password"
              className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-gray-700"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type="submit"
              className="w-full border text-black py-2 rounded hover:bg-gray-800 hover:text-white transition mb-4"
            >
              Register
            </button>

            <p className="text-sm text-gray-600">
              Already have an account?{" "}
              <Link to="/login" className="text-blue-600 hover:underline">
                Sign in here
              </Link>
            </p>
          </form>
        </div>
      </div>
    </>
  );
}
